import Step1 from './step1';
import Step2 from './step2';
import OTPVertification from './OTPVertification'

export {
    Step1,
    Step2,
    OTPVertification,
}